import { render, staticRenderFns } from "./DetailShift.vue?vue&type=template&id=0771b2a3&scoped=true"
import script from "./DetailShift.vue?vue&type=script&lang=js"
export * from "./DetailShift.vue?vue&type=script&lang=js"
import style0 from "./DetailShift.vue?vue&type=style&index=0&id=0771b2a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771b2a3",
  null
  
)

export default component.exports